import { render, staticRenderFns } from "./CardExerciseOverview.vue?vue&type=template&id=4bb8a450&scoped=true"
import script from "./CardExerciseOverview.vue?vue&type=script&lang=js"
export * from "./CardExerciseOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb8a450",
  null
  
)

export default component.exports